import React, { useState, useEffect } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import './style.css';

const Scrollbar = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        setIsVisible(window.scrollY > 300);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="col-lg-12">
            {isVisible && (
                <div className="header-menu">
                    <ul className="smothscroll">
                        <li>
                            <AnchorLink href="#scrool">
                                <i className="ti-arrow-up"></i>
                            </AnchorLink>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default Scrollbar;
